/* 中文语言配置*/
module.exports = {
  text: 'English',
  base: {
    FullLoaded: 'Full Loaded！',
    NoData: 'No Data',
    ScanLoc: 'Scan Loc',
    ScanBox: 'Scan Box'
  },
  tabbar: {
    Awaiting: 'Awaiting',
    BoxScan: 'Box Scan',
    ItemScan: 'Item Scan'
  },
  login: { // 登录
    messages: {
      userName: '用户名不能为空!',
      password: '密码不能为空！'
    },
    placeholder: {
      userName: '请输入用户名',
      password: '请输入密码'
    },
    button: {
      SignIn: '登录'
    }
  },
  home: { // 首页
    menu: {
      Cycle: 'Cycle',
      Transfer: 'Transfer'
    },
    button: {
      Setting: '设置',
      Quit: '退出'
    }
  },
  setting: { // 设置
    title: 'Setting',
    menus: {
      DownloadThe: '下载最新版本',
      switchLanguage: '切换语言',
      CurrentVersionNumber: '当前版本号'
    }
  },
  Cycle: { // 盘点
    title: '盘点任务',
    tabbar: {
      Checking: '待盘点',
      ReCheck: '待复盘'
    },
    label: {
      ScanAisle: '扫库位'
    },
    placeholder: {
      ScanAisle: '请扫描库位'
    },
    taskList: {
      CycleNo: '盘点单号',
      CheckAisle: '盘点库位',
      JobType: '任务类型',
      stcheck: '初盘',
      ReCheck: '复盘',
      StartingTime: '任务时间'
    }
  },
  CycleDetails: {
    title: '盘点详情',
    tabbar: {
      ExpectedInfo: '待盘点信息',
      Confirm: '盘点确认'
    },
    tableData: {
      CyclePallet: '盘点托盘',
      QtyExp: '预期数量',
      BoxExp: '预期箱数'
    },
    tableTitle: {

    }
  }

}



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js